export { AcademicInformationTabComponent } from './academic-information-tab/academic-information-tab.component';
export { GeneralInfoCampaignTabComponent } from './general-information-tab/general-information-tab.component';
